import React from 'react';
import DataList from './DataList';
import ApiConfigFactory from '../configurations/ApiConfigFactory';

const MfaSettings = () => {
  // Initialize apiConfig using ApiConfigFactory
  const apiConfig = new ApiConfigFactory('mfa/settings', 'MFA Settings');
  
  // Configure properties
  apiConfig.defaultSortFieldId = 'id';
  apiConfig.defaultSortAsc = false;
  apiConfig.path = '/mfa-settings';
  apiConfig.allowAdd = true;
  apiConfig.allowEdit = true;
  apiConfig.allowDelete = true;
  
  // Custom validation to ensure either user or role is provided
  apiConfig.additionalValidation = (formData) => {
    let error = {};
    
    // Either user_id or role_name must be provided
    if (!formData.user_id && !formData.role_name) {
      error.message = 'Either a User or a Role Name must be provided';
      error.isValid = false;
      return error;
    }
    
    error.isValid = true;
    return error;
  };

  // Add fields
  apiConfig
    .addField({ name: 'id', label: 'ID', type: 'text', disabled: true, identifier: true, visible: false, tab: 'Main' })
    .addField({ name: 'user_id', label: 'User', type: 'dropdown', required: false, tab: 'Main', width: '250px' })
    .addField({ 
      name: 'role_name', 
      label: 'Role', 
      type: 'dropdown', 
      required: false, 
      tab: 'Main',
      width: '200px',
      helpText: 'Leave empty for user-specific settings, or select a role for role-based defaults'
    })
    .addField({ name: 'enabled', label: 'MFA Enabled', type: 'checkbox', required: false, defaultValue: false, tab: 'Main' })
    .addField({ name: 'require_on_new_device', label: 'Require on New Device', type: 'checkbox', required: false, defaultValue: true, tab: 'Triggers' })
    .addField({ name: 'require_on_new_ip', label: 'Require on New IP Address', type: 'checkbox', required: false, defaultValue: false, tab: 'Triggers' })
    .addField({ 
      name: 'require_on_user_switch', 
      label: 'Require on User Switch', 
      type: 'checkbox', 
      required: false, 
      defaultValue: false, 
      tab: 'Triggers',
      helpText: 'Require MFA when switching between users on the same device'
    })
    .addField({ 
      name: 'require_after_days', 
      label: 'Re-verify After Days', 
      type: 'number', 
      required: false, 
      defaultValue: 30, 
      tab: 'Triggers',
      min: 1,
      max: 365,
      helpText: 'Number of days before requiring MFA re-verification (1-365)'
    });
  
  // Add dropdown fields
  apiConfig
    .addDropdownField({
      name: 'user_id',
      endpoint: '/hospital-portal/api/users',
      valueField: 'id',
      labelField: 'name',
    })
    .addDropdownField({
      name: 'role_name',
      endpoint: '/hospital-portal/api/roles',
      valueField: 'name',
      labelField: 'name',
    });
  
  // Add tabs
  apiConfig
    .addTab({ name: 'Main', roles: 'all', default: true })
    .addTab({ name: 'Triggers', roles: 'all' });
  
  // Add columns
  apiConfig
    .addColumn({ name: 'ID', selector: (row) => row.id, sortable: true, identifier: true, width: '60px' })
    .addColumn({ name: 'User', selector: (row) => row.User?.name || row.user_id, sortable: true, filterable: true, filterSelector: 'user_id' })
    .addColumn({ name: 'Role', selector: (row) => row.role_name || 'N/A', sortable: true, width: '100px' })
    .addColumn({ name: 'Enabled', selector: (row) => row.enabled ? '✓' : '✗', sortable: true, width: '80px', center: true })
    .addColumn({ name: 'New Device', selector: (row) => row.require_on_new_device ? '✓' : '✗', width: '100px', center: true })
    .addColumn({ name: 'New IP', selector: (row) => row.require_on_new_ip ? '✓' : '✗', width: '80px', center: true })
    .addColumn({ name: 'User Switch', selector: (row) => row.require_on_user_switch ? '✓' : '✗', width: '100px', center: true })
    .addColumn({ name: 'Re-verify Days', selector: (row) => row.require_after_days || 30, sortable: true, width: '120px' });

  return <DataList apiConfig={apiConfig} columns={apiConfig.columns} />;
};

export default MfaSettings;
